import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VEHICLE_VALUATION_RESOURCE } from "./use-vehicle-valuation-search.query";

const VEHICLE_RESOURCE = "vehicle" as const;

export const VEHICLE_VALUATION_CREATE_API_PATH = `/v1/${VEHICLE_VALUATION_RESOURCE}` as const;

export type VehicleValuationCreateBody =
  paths[typeof VEHICLE_VALUATION_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type VehicleValuationCreateResponse = paths[typeof VEHICLE_VALUATION_CREATE_API_PATH]["post"]["responses"][
  | 200
  | 201]["content"]["application/json"];

export const useVehicleValuationCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<VehicleValuationCreateResponse, Error, VehicleValuationCreateBody>({
    mutationFn: async (data: VehicleValuationCreateBody) => {
      const response = await alphartisApiAxios.post<VehicleValuationCreateResponse>(
        VEHICLE_VALUATION_CREATE_API_PATH,
        data,
      );
      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_VALUATION_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_RESOURCE],
        }),
      ]);
    },
  });
};
